/**
 * Created by Ning Jiang on 8/15/2018.
 */

import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {IceIceYetiWildPresentationEvent} from "../event/IceIceYetiWildPresentationEvent";
import {IceIceYetiSoundConfig} from "../IceIceYetiSoundConfig";
import {IceIceYetiReelIceController} from "../reelice/IceIceYetiReelIceController";
import {IceIceYetiParsedGameData} from "../server/data/IceIceYetiParsedGameData";

export class RandomFeatureController extends BeforeSpinStopPresentationController {

    private _openPositions:PIXI.Point[] | null;

    constructor(index:number) {
        super(index, "randomFeature");
    }

    protected parseFeatureTriggered(data:IceIceYetiParsedGameData):boolean {
        this._openPositions = data.randomFeatureOpenPositions;
        return data.randomFeatureTriggered;
    }

    protected getSpinStopDelay(data:IceIceYetiParsedGameData):number {
        return GameSetting.isFastSpin ? 1.5 : 3;
    }

    protected startPresentation(timeline:TimelineLite):void {
        timeline.add(() => {
            SlotGame.sound.playEffect(IceIceYetiSoundConfig.instance.ICE_SHAKING);
        });
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(IceIceYetiReelIceController.PLAY_ALL_ICE_SHAKE));
        });
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(IceIceYetiReelIceController.STOP_ALL_ICE_SHAKE));
        }, GameSetting.isFastSpin ? 1 : 2.5);
        // open all positions.
        if(!this._openPositions) {
            debugger;
            throw new Error("RandomFeatureController.startPresentation(): The open positions data is null!");
        }
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(IceIceYetiWildPresentationEvent.CRACK_ICE, this._openPositions)));

        timeline.play();
    }

    protected stopPresentation(isAborted:boolean):void {
        SlotGame.sound.stopEffect(IceIceYetiSoundConfig.instance.ICE_SHAKING);
    }

    protected resetFeature() {
        this._openPositions = null;
    }
}